export const environment = {
  production: false,
  application: "DEVELOP",
  api_url: "https://develop.api.yooga.internal/",
  nest_delivery_api: "https://develop.delivery.yooga.internal/",
  whatsapp_api_v2: "https://develop.whatsapp-api.yooga.internal/",
  api_quarkus_integrations: "https://develop.integrations.ms.yooga.internal/",
  redirect_url: "https://develop.app.yooga.internal/login",
  amplitude_api_key: "977d1fd630f9c52364809cef76304561",
};
